const STORAGE_PREFIX = "chat-compose-draft";

function storageKey(accountId: number, threadId: number): string {
  return `${STORAGE_PREFIX}:${accountId}:${threadId}`;
}

/** Unsent compose text for a doctor + thread (mini chat / full chat). */
export function readChatComposeDraft(accountId: number | undefined, threadId: number): string {
  if (!accountId || !threadId) {
    return "";
  }
  try {
    return window.localStorage.getItem(storageKey(accountId, threadId)) ?? "";
  } catch {
    return "";
  }
}

export function writeChatComposeDraft(
  accountId: number | undefined,
  threadId: number,
  text: string,
): void {
  if (!accountId || !threadId) {
    return;
  }
  const key = storageKey(accountId, threadId);
  try {
    if (!text) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, text);
    }
  } catch {
    /* private mode / quota */
  }
}

export function clearChatComposeDraft(accountId: number | undefined, threadId: number): void {
  writeChatComposeDraft(accountId, threadId, "");
}
